/**
 * ADBLOCKER ULTRA v3.0 - El bloqueador definitivo para videos
 * Bloquea TODO: iframes, overlays, popups, requests, scripts maliciosos
 */

class AdBlockerUltra {
    constructor() {
        this.stats = { blocked: 0, iframes: 0, requests: 0, elements: 0 };
        this.init();
    }

    init() {
        console.log('🔥 ADBLOCKER ULTRA ACTIVADO - Modo GOD');

        // 1. BLOQUEO INMEDIATO
        this.killAllAds();

        // 2. OBSERVER ULTRA RÁPIDO
        this.startHyperObserver();

        // 3. INTERVALOS MÚLTIPLES
        this.startMultiIntervals();

        // 4. HOOKS COMPLETOS
        this.hookAllRequests();

        // 5. CSS INYECCIÓN
        this.injectKillCSS();

        // 6. WEBWORKER para background scanning
        this.startWorker();

        // Export global instance for debugging
        window.adBlockerUltra = this;
    }

    // 🔪 KILLER PRINCIPAL - Mata TODO
    killAllAds() {
        this.killIframes();
        this.killElements();
        this.killOverlays();
        this.killScripts();
        this.killVideosAds();
    }

    // 🎯 IFRAMES KILLER (99.9% efectividad)
    killIframes() {
        document.querySelectorAll('iframe, embed, object').forEach(el => {
            const src = (el.src || el.data || '').toLowerCase();
            const rect = el.getBoundingClientRect();

            // Patrones de ANUNCIOS
            const adPatterns = [
                /ads|advert|banner|popup|overlay|preroll|midroll|interstitial/i,
                /googleadservices|doubleclick|googlesyndication|pagead/i,
                /scorecardresearch|yieldmanager|adserver/i
            ];

            if (adPatterns.some(pattern => pattern.test(src)) ||
                (!src && rect.height < 300) ||
                (rect.width > window.innerWidth * 0.8 && rect.height < 200)) {

                // Don't kill the main video player if it's legitimate (we might need to refine this whitelist)
                // For now, relying on the pattern check.
                // NOTE: User's logic is aggressive. It might kill the main player if the player has "ad" in URL or small size initially.
                // We'll trust the logic for now but might need to whitelist 'vimeos.net', 'goodstream.one' explicitly if they get caught.

                // Whitelist legitimate players just in case
                if (src.includes('vimeos.net') || src.includes('goodstream.one')) return;

                this.nukeElement(el);
                this.stats.iframes++;
            }
        });
    }

    // 💥 ELEMENTOS KILLER (selectores avanzados)
    killElements() {
        const killers = [
            '[class*="ad-"],[id*="ad-"],[class*="ads"],[id*="ads"]',
            '.advertisement,.advert,.banner,.popup,.overlay,.sponsored',
            '.video-ad,.preroll,.midroll,.postroll,[data-ad]',
            '.ytp-ad-module,.ad-container,.ad-overlay',
            'div[style*="position: fixed"],div[style*="z-index: 9999"]'
        ];

        killers.forEach(selector => {
            document.querySelectorAll(selector).forEach(el => {
                // Whitelist
                if (el.hasAttribute('data-radix-portal') ||
                    el.closest('[data-radix-popper-content-wrapper]') ||
                    el.closest('[role="menu"]')) return;

                this.nukeElement(el);
                this.stats.elements++;
            });
        });
    }

    // 🛡️ OVERLAYS & POPUPS KILLER
    killOverlays() {
        document.querySelectorAll('*').forEach(el => {
            // Whitelist Radix UI & App Components
            const classList = el.getAttribute('class') || '';
            if (el.hasAttribute('data-radix-portal') ||
                el.getAttribute('role') === 'dialog' ||
                el.getAttribute('role') === 'menu' ||
                el.closest('[data-radix-popper-content-wrapper]') ||
                classList.includes('radix') ||
                classList.includes('Toast') ||
                classList.includes('dialog')) {
                return;
            }

            const style = window.getComputedStyle(el);
            const rect = el.getBoundingClientRect();

            if ((style.position === 'fixed' || style.position === 'absolute') &&
                (rect.width > window.innerWidth * 0.7 || rect.height > 100) &&
                (style.zIndex === '999999' || parseInt(style.zIndex) > 10000)) {

                this.nukeElement(el);
            }
        });
    }

    // 🎬 VIDEO ADS KILLER (YouTube, etc)
    killVideosAds() {
        // YouTube ads
        const ytAd = document.querySelector('.video-ads.ypp-ad, .ytp-ad-module');
        if (ytAd) ytAd.remove();

        // Skip button injection
        setTimeout(() => {
            const skipBtn = document.querySelector('.ytp-ad-skip-button, .skip-button');
            if (skipBtn) skipBtn.click();
        }, 1000);
    }

    // Placeholder for killScripts if missing from original user snippet but called in killAllAds
    killScripts() {
        // Implementation implicit? User provided snippet calls it.
        // We will remove scripts that look suspicious
        const scripts = document.querySelectorAll('script[src*="ads"], script[src*="tracker"]');
        scripts.forEach(s => s.remove());
    }

    // 💣 NUKE TOTAL (elimina sin piedad)
    nukeElement(el) {
        el.remove ? el.remove() : el.parentNode.removeChild(el);
        this.stats.blocked++;
    }

    // 👁️ OBSERVER HYPER RÁPIDO (50ms)
    startHyperObserver() {
        const observer = new MutationObserver((mutations) => {
            let needsKill = false;
            mutations.forEach(m => {
                if (m.addedNodes.length) needsKill = true;
            });
            if (needsKill) requestAnimationFrame(() => this.killAllAds());
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'src']
        });
    }

    // ⏱️ INTERVALOS MÚLTIPLES (ultra agresivo)
    startMultiIntervals() {
        // Ultra rápido para iframes
        setInterval(() => this.killIframes(), 500);
        // Rápido para elementos
        setInterval(() => this.killElements(), 1000);
        // Overlays cada segundo
        setInterval(() => this.killOverlays(), 1500);
        // Full scan cada 3s
        setInterval(() => this.killAllAds(), 3000);
    }

    // 🌐 REQUESTS BLOCKER COMPLETO
    hookAllRequests() {
        // Fetch interceptor
        const originalFetch = window.fetch;
        window.fetch = (input, init) => {
            const url = typeof input === 'string' ? input : (input.url || '');
            if (this.isAdUrl(url)) {
                this.stats.requests++;
                return Promise.reject('AD BLOCKED');
            }
            return originalFetch(input, init);
        };

        // XMLHttpRequest interceptor  
        const originalXHROpen = XMLHttpRequest.prototype.open;
        const self = this; // Fix: Capture correct 'this' context
        XMLHttpRequest.prototype.open = function (method, url) {
            if (self.isAdUrl(url)) {
                self.stats.requests++;
                this.abort();
                return;
            }
            return originalXHROpen.apply(this, arguments);
        };
    }

    isAdUrl(url) {
        if (!url) return false;
        const adDomains = [
            'ads', 'advert', 'banner', 'popup', 'googleadservices',
            'doubleclick', 'googlesyndication', 'pagead', 'scorecardresearch'
        ];
        return adDomains.some(domain => url.includes(domain));
    }

    // 💅 CSS KILLER INYECCIÓN
    injectKillCSS() {
        const style = document.createElement('style');
        style.textContent = `
            /* Ultra CSS Kill */
            iframe[src*="ads"], iframe[src*="googlead"] { display: none !important; }
            .ad, .ads, [class*="ad-"], .advertisement { display: none !important; }
            div[style*="position: fixed"][style*="z-index: 999"] { display: none !important; }
            .ytp-ad-module, .video-ads { display: none !important; }
        `;
        document.head.appendChild(style);
    }

    // 👷 WEBWORKER BACKGROUND SCANNER
    startWorker() {
        if (window.Worker) {
            const workerCode = `
                setInterval(() => {
                    postMessage('scan');
                }, 2000);
            `;

            const blob = new Blob([workerCode], { type: 'application/javascript' });
            const worker = new Worker(URL.createObjectURL(blob));

            worker.onmessage = () => this.killAllAds();
        }
    }

    // 📊 STATS DISPLAY
    showStats() {
        console.clear();
        console.log(`🎬 ADBLOCKER ULTRA STATS:
🛑 Total bloqueados: ${this.stats.blocked}
📺 Iframes: ${this.stats.iframes}
🌐 Requests: ${this.stats.requests}
🔤 Elementos: ${this.stats.elements}`);
    }
}

export default AdBlockerUltra;
